import { AssetActionHandlers } from '@/sections/asset/types';
import { Asset } from '@/types';
import type { DropdownOption } from '@/types/dropdown.types';

import { getAssetAnnotateOptions } from './annotateOptions';
import { getAssetDistributeOptions } from './distributeOptions';
import { getAssetScanOptions } from './scanOptions';
import { getAssetStatusOptions } from './statusOptions';

export interface GetAssetActionOptionsParams {
  /** Assets to perform actions on */
  assets: Asset[];
  /** Handler for opening comment modal */
  onCommentClick?: () => void;
  /** Handler for opening tag modal */
  onTagClick?: () => void;
  /** Action handlers for scan, status, and share operations */
  handlers: AssetActionHandlers;
  /** User agentselection state from global state */
  selectUserAgent: { onAssetKeysChange: (keys: string[]) => void };
  /** Whether the current user is a Praetorian user */
  isPraetorianUser: boolean;
}

export const getAssetActionOptions = ({
  assets,
  onCommentClick,
  onTagClick,
  handlers,
  selectUserAgent,
  isPraetorianUser,
}: GetAssetActionOptionsParams): DropdownOption[] => {
  const annotateOptions = getAssetAnnotateOptions({
    onCommentClick,
    onTagClick,
  });

  const scanOptions = getAssetScanOptions({
    assets,
    handlers,
    selectUserAgent,
    isPraetorianUser,
  });

  const distributeOptions = getAssetDistributeOptions({
    assets,
    handlers,
  });

  const statusOptions = getAssetStatusOptions({
    assets,
    handlers,
  });

  // Combine all options with dividers between groups
  return [
    ...annotateOptions,
    { label: '', isDivider: true },
    ...scanOptions,
    { label: '', isDivider: true },
    ...distributeOptions,
    { label: '', isDivider: true },
    ...statusOptions,
  ];
};
